// extracted by mini-css-extract-plugin
export default {"Carousel":"RotatingCarousel_Carousel__5B20G","List":"RotatingCarousel_List__xC8E-","ListItem":"RotatingCarousel_ListItem__ekt+T","MoreSlot":"RotatingCarousel_MoreSlot__cjlzK"};